import { createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH } from "constants/api";
import axios from "utils/http";

export interface ILoginArgs extends ReduxAction {
  loginPayload: ILogin;
}

interface IResetPasswordArgs extends ReduxAction {
  payload: IResetPassword;
  token: string;
}

interface IForgotPasswordArgs extends ReduxAction {
  payload: IForgotPassword;
}

interface IEmptyArgs extends ReduxAction {
}

interface IConfirm2FAArgs extends ReduxAction {
  payload: { code: string };
}

interface IEnable2FAResponse extends ApiResponse {
  data?: { qr_code?: string };
}

interface IVerify2FAArgs extends ReduxAction {
  payload: IVerify2FAPayload;
}

export interface ILoginResponse extends ApiResponse {
  data: ILoginResponseData;
}

export const login = createAsyncThunk(
  AUTH.LOGIN,
  async (
    { loginPayload, onSuccess, onFailure }: ILoginArgs,
    { rejectWithValue }
  ) => {
    try {
      const { data }: ILoginResponse = await axios.post(
        AUTH.LOGIN,
        loginPayload
      );
      if (onSuccess) onSuccess(data);
      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const createPassword = createAsyncThunk(
  AUTH.INVITE,
  async (
    { payload, token, onSuccess, onFailure }: IResetPasswordArgs,
    { rejectWithValue }
  ) => {
    try {
      const response: ApiResponse = await axios.post(
        AUTH.INVITE.replace(":token", token),
        payload
      );
      if (onSuccess) onSuccess(response);
      return response;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const resetPassword = createAsyncThunk(
  AUTH.SET_PASSWORD,
  async (
    { payload, token, onSuccess, onFailure }: IResetPasswordArgs,
    { rejectWithValue }
  ) => {
    try {
      const response: ApiResponse = await axios.post(
        AUTH.SET_PASSWORD.replace(":token", token),
        payload
      );
      if (onSuccess) onSuccess(response);
      return response;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const sendResetLink = createAsyncThunk(
  AUTH.RESET_PASSWORD,
  async (
    { payload, onSuccess, onFailure }: IForgotPasswordArgs,
    { rejectWithValue }
  ) => {
    try {
      const response: ApiResponse = await axios.post(
        AUTH.RESET_PASSWORD,
        payload
      );
      if (onSuccess) onSuccess(response);
      return response;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const enable2FA = createAsyncThunk(
  AUTH.ENABLE_2FA,
  async (
    { onSuccess, onFailure }: IEmptyArgs,
    { rejectWithValue }
  ) => {
    try {
      const response: IEnable2FAResponse = await axios.post(
        AUTH.ENABLE_2FA,
      );
      if (onSuccess) onSuccess(response);
      return response;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const confirm2FA = createAsyncThunk(
  AUTH.CONFIRM_2FA,
  async (
    { payload, onSuccess, onFailure }: IConfirm2FAArgs,
    { rejectWithValue }
  ) => {
    try {
      const response: ApiResponse = await axios.post(
        AUTH.CONFIRM_2FA,
        payload
      );
      if (onSuccess) onSuccess(response);
      return response;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const verify2FA = createAsyncThunk(
  AUTH.VERIFY_2FA,
  async (
    { payload, onSuccess, onFailure }: IVerify2FAArgs,
    { rejectWithValue }
  ) => {
    try {
      const response: ApiResponse = await axios.post(AUTH.VERIFY_2FA, payload);
      if (onSuccess) onSuccess(response);
      return response;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

